import { MarketEnum } from "../../../Enums/MarketEnum";
import { DoubleChanceEnum } from "../../../Enums/ValueEnums";
import ValueDoubleChance from "../../Value/ValueDoubleChance";
import FixturesModel from "../FixturesModel";

export default class DoubleChanceFixtureModel implements FixturesModel {
    public matchId: string = null;
    public market: MarketEnum = MarketEnum.DOUBLE_CHANCE;
    public matchType: string = "FOOTBALL";
    public prediction: ValueDoubleChance = null;

    constructor(matchId: string, value: DoubleChanceEnum) {
        this.matchId = matchId;
        this.prediction = new ValueDoubleChance();
        this.prediction.value = value;
    }
}